import DesignNotePin from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/design_management/design_note_pin.vue?vue3';
function calcPercent(pos, renderedSize) {
    return 100 * pos / renderedSize;
}
export default {
    name: 'BaseImageDiffOverlay',
    components: {
        DesignNotePin
    },
    props: {
        discussions: {
            type: Array,
            required: true
        },
        commentForm: {
            type: Object,
            required: false,
            default: null
        },
        canComment: {
            type: Boolean,
            required: false,
            default: false
        },
        showCommentIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        badgeClass: {
            type: String,
            required: false,
            default: ''
        },
        shouldToggleDiscussion: {
            type: Boolean,
            required: false,
            default: true
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
        renderedWidth: {
            type: Number,
            required: true
        },
        renderedHeight: {
            type: Number,
            required: true
        }
    },
    emits: [
        'image-click',
        'pin-click'
    ],
    computed: {
        nonDraftDiscussions () {
            return this.discussions.filter((d)=>!d.isDraft);
        },
        formPosition () {
            return {
                left: `${this.commentForm.xPercent}%`,
                top: `${this.commentForm.yPercent}%`
            };
        }
    },
    methods: {
        imageDimensions () {
            return {
                width: Math.round(this.width),
                height: Math.round(this.height)
            };
        },
        getPositionForObject (meta) {
            const { x, y, width, height } = meta;
            return {
                x: x / width * 100,
                y: y / height * 100
            };
        },
        getPosition (discussion) {
            const { x, y } = this.getPositionForObject(discussion.position);
            return {
                left: `${x}%`,
                top: `${y}%`
            };
        },
        toggleText (discussion, index) {
            const count = index + 1;
            return discussion.isDraft ? count - this.nonDraftDiscussions.length : count;
        },
        clickedImage (x, y) {
            const { width, height } = this.imageDimensions();
            const xPercent = calcPercent(x, this.renderedWidth);
            const yPercent = calcPercent(y, this.renderedHeight);
            this.$emit('image-click', {
                width,
                height,
                x: Math.round(width * (xPercent / 100)),
                y: Math.round(height * (yPercent / 100)),
                xPercent,
                yPercent
            });
        }
    }
};
